import React, { useEffect } from "react";
import "../../css/Subscriber.css";
import { useDispatch, useSelector, UseSelector } from "react-redux";
import {
  fetchAsyncSubscriber,
  fetchAsyncSubscMonthWeek,
  SubscriberUpdatedTime
} from "./SubscriberSlice";
import { SubscriberInfo } from "./SubscriberSlice";
import TotalSubsc from "./total/TotalSubsc";
import MonthSubsc from "./month/MonthSubsc";
import TotalAuth from "./total/TotalAuth";
import MonthAuth from "./month/MonthAuth";
import MonthTransSubsc from "./month/MonthTransSubsc";
import TotalWeekSubsc from "./total/TotalWeekSubsc";
import TotalAgeSubsc from "./total/TotalAgeSubsc";
import MonthWeekSubsc from "./month/MonthWeekSubsc";
import MonthAgeSubsc from "./month/MonthAgeSubsc";
import WeekLineSubsc from "./week/WeekLineSubsc";

const Subscriber = () => {
  const SubscriberInfoData = useSelector(SubscriberInfo);

  const dispatch = useDispatch();
  const totalSubscSum = SubscriberInfoData?.total.reduce((sum: any, item: any) => sum + item.subsc, 0) || 0;
  const totalAuthSum = SubscriberInfoData?.total.reduce((sum: any, item: any) => sum + parseInt(item.auth, 10), 0) || 0;

  const subscriberUpdatedTime = useSelector(SubscriberUpdatedTime);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncSubscriber());

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncSubscriber());
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  return (
    <div className="position_row">
      <div className="dashboard_container_subsc">
        <h1 className="dashboard_title_subsc">利用状況 -登録者数-</h1>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {subscriberUpdatedTime}</div>
        {SubscriberInfoData && (
          <div className="graph_container_subsc">
            <div className="box-container_subsc">
            <TotalSubsc TotalSubsc={totalSubscSum} />
              <MonthSubsc
                ThisMonth={SubscriberInfoData!.thismonth["subsc"]}
                LastMonth={SubscriberInfoData!.last_month["subsc"]}
              />
              <TotalAuth TotalAuth={totalAuthSum} />
              <MonthAuth
                ThisMonth={SubscriberInfoData!.thismonth["auth"]}
                LastMonth={SubscriberInfoData!.last_month["auth"]}
              />
            </div>
            <MonthTransSubsc MonthTransSubsc={SubscriberInfoData!.month_user} />
            <WeekLineSubsc />
            <TotalWeekSubsc TotalWeekSubsc={SubscriberInfoData!.total_week} />
            <TotalAgeSubsc TotalAgeSubsc={SubscriberInfoData!.total_age} />
            <MonthWeekSubsc />
            <MonthAgeSubsc />
          </div>
        )}
      </div>
    </div>
  );
};

export default Subscriber;
